/**
 * The guest's password on the thank-you page: the order is placed, the account
 * is made by setting a password.
 *
 * Markup contract (guest-add-password module, widget/dd_guest_add_password_widget.html.twig):
 *   <form x-data="validatedForm" @submit="submit($event)" …>
 *     <div x-data="guestPassword">
 *       <div class="alert alert-danger" x-show="errors.length">
 *
 * The widget answers with its own markup: either the field errors the server found
 * or the whole box again, then carrying the success message. Nothing is sent a
 * second time, so the submit hook never lets the form through.
 */
import { postAction } from '../shell/request.js';

document.addEventListener('alpine:init', () => {
    Alpine.data('guestPassword', () => ({
        errors: [],

        init() {
            this.addBeforeSubmit(() => this.save());
        },

        async save() {
            const form = this.$el.closest('form');
            const body = new FormData(form);
            body.set('renderPartial', 'true');

            const answer = await postAction(form.action || window.location.href, body);
            this.errors = answer.errors?.guest_password ?? [];

            if (!this.errors.length) {
                document.getElementById('guestUserWrapper').outerHTML = answer.content;
            }

            return false;
        },
    }));
});
